import React, { useEffect, useState } from "react";
import useToken from "../../useToken.js";
import { baseUrl } from '../../config.js';
import Modal from "../Modal/Modal";
import "./Contacta.css";

const chatIcon = (
    <svg
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        style={{ marginRight: 8 }}
    >
        <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            strokeLinejoin="round"
            strokeLinecap="round"
        />
    </svg>
);

const Contacta = () => {
    const {token} = useToken();
    const [modal, setModal] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [medio, setMedio] = useState("chat");
    const [cuando, setCuando] = useState('ahora');
    const [dia, setDia] = useState(new Date());
    const [chat, setChat] = useState(false);

    const handleEnviar = (e) => {
        e.preventDefault();
        // Aquí puedes manejar el envío del mensaje
        fetch(`${baseUrl}Messages/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                message:mensaje,
                contactType : medio === "chat" ? "message" : "call",
                dateTime: cuando,
                url: window.location.href,
            }),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al enviar el mensaje');
            }
            return response.json();
        })
        .then(data => {
            console.log("Mensaje enviado:", data);
            // Aquí puedes manejar la respuesta del servidor
            window.alert("Tu mensaje ha sido enviado correctamente. Un asesor se pondrá en contacto contigo pronto.");
        })
        .catch(error => {
            console.error("Error al enviar el mensaje:", error);
            // Aquí puedes manejar el error
            alert("Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo más tarde.");
        });
        setMensaje("");
        setModal(false);
    };

    // Función para limitar el horario permitido
    const limitarHorario = (fecha) => {
        const diaSemana = fecha.getDay(); // 0=Domingo, 1=Lunes, ..., 6=Sábado
        const hora = fecha.getHours();
        const minutos = fecha.getMinutes();

        // Lunes a Viernes
        if (diaSemana >= 1 && diaSemana <= 5) {
            if (hora < 9) return false;
            if (hora > 18 || (hora === 18 && minutos > 0)) return false;
            return true;
        }
        // Sábado
        if (diaSemana === 6) {
            if (hora < 9) return false;
            if (hora > 14 || (hora === 14 && minutos > 0)) return false;
            return true;
        }
        // Domingo no permitido
        return false;
    };

    return (
        <>
            {modal &&
                <Modal
                    titulo="Contacta con un asesor"
                    setModal={setModal}
                    className="contacta-modal"
                >
                    <div className="content-contacta">
                        <section className="info-contacta">
                            <h3>¿Tienes dudas?</h3>
                            <p>
                                Si tienes alguna pregunta o necesitas ayuda, no dudes en contactar a uno de nuestros asesores.
                                Estamos aquí para ayudarte con cualquier consulta que puedas tener.
                            </p>
                            <div className="horario-contacta" style={{ margin: "16px 0", color: "#666" }}>
                                <strong>Horario de atención:</strong> Lunes a Viernes de 9:00 a 18:00 hrs. Sábados de 9:00 a 14:00 hrs.
                            </div>
                        </section>
                        <section className="mensaje-contacta">
                            {medio !== "chat" &&
                                <button onClick={()=>{
                                    setMedio("chat");
                                }}>Prefiero enviar un mensaje</button>
                            }
                            {medio === "chat" &&
                                <form onSubmit={handleEnviar}>
                                    <textarea
                                        className="contacta-textarea"
                                        placeholder="Describe tu duda aquí..."
                                        value={mensaje}
                                        onChange={e => setMensaje(e.target.value)}
                                        rows={4}
                                        required
                                        />
                                    <button
                                        type="submit"
                                        className="contacta-enviar-btn"
                                        >
                                        Enviar
                                    </button>
                                </form>
                            }
                        </section>
                        <section className="llamada-contacta">
                            {medio === "chat" &&
                                <button onClick={()=>{
                                    setMedio("llamada");
                                }}>Prefiero que me llamen</button>
                            }
                            {medio === "llamada" &&
                                <div className="contacta-llamada">
                                    <p>
                                        Para recibir una llamada de uno de nuestros asesores, por favor proporciona tu número de teléfono.
                                    </p>
                                    <form onSubmit={handleEnviar}>
                                        <input
                                            type="tel"
                                            className="contacta-input"
                                            placeholder="Tu número de teléfono"
                                            value={mensaje}
                                            required
                                        />
                                        <textarea
                                            className="contacta-textarea"
                                            placeholder="Describe tu duda aquí..."
                                            value={mensaje}
                                            onChange={e => setMensaje(e.target.value)}
                                            rows={4}
                                            required
                                        />
                                        <div className="contacta-datetime">
                                            <label>
                                                ¿Cuándo te gustaría que te llamemos?
                                            </label>
                                            <select
                                                value={cuando}
                                                onChange={e => setCuando(e.target.value)}
                                            >
                                                <option value="ahora">Lo más pronto posible</option>
                                                <option value="agendar">Agendar llamada</option>
                                            </select>
                                            {cuando === "agendar" && (
                                                <>
                                                    <input
                                                        type="datetime-local"
                                                        value={dia.toISOString().slice(0,16)}
                                                        onChange={e => {
                                                            const nuevaFecha = new Date(e.target.value);
                                                            setDia(nuevaFecha);
                                                        }}
                                                        min={(() => {
                                                            // Mínimo: ahora o siguiente horario válido
                                                            const ahora = new Date();
                                                            if (limitarHorario(ahora)) {
                                                                return ahora.toISOString().slice(0,16);
                                                            }
                                                            // Buscar siguiente horario válido
                                                            let siguiente = new Date(ahora);
                                                            siguiente.setMinutes(0,0,0);
                                                            while (!limitarHorario(siguiente)) {
                                                                siguiente.setHours(siguiente.getHours() + 1);
                                                            }
                                                            return siguiente.toISOString().slice(0,16);
                                                        })()}
                                                    />
                                                    {!limitarHorario(dia) && (
                                                        <div style={{color: "red", fontSize: 13, marginTop: 4}}>
                                                            El horario debe ser Lunes a Viernes de 9:00 a 18:00 o Sábados de 9:00 a 14:00.
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        <button
                                            type="submit"
                                            className="contacta-enviar-btn"
                                            disabled={cuando === "agendar" && !limitarHorario(dia)}
                                        >
                                            Enviar
                                        </button>
                                    </form>
                                </div>
                            }
                        </section>
                    </div>
                </Modal>
            }
            {!chat &&
                <div className="contacta-container">
                    <div className="contacta-wrapper">
                        <div>
                            {chatIcon}
                            <span style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                                ¿Tienes dudas?
                            </span>
                        </div>
                        <button className="contacta-text" onClick={() => setModal(true)}>Contacta un asesor.</button>
                        <button className="contacta-text" onClick={() => setChat(true)}>Iniciar Chat.</button>
                    </div>
                </div>
            }
            {chat &&
                <div className="contacta-chat">
                    <div className="chatbot-container">
                        <div className="chatbot-header">
                            <span>Chat en línea</span>
                            <button className="chatbot-close" onClick={() => setChat(false)}>×</button>
                        </div>
                        <ChatBot />
                    </div>
                </div>
            }
        </>
    );
};

const ChatBot = () => {
    const {token} = useToken();
    const [loading, setLoading] = useState(false);
    const [idSupport, setIdSupport] = useState(null);
    const [messages, setMessages] = useState([
        { text: "¡Hola! 👋 Soy tu asistente virtual. ¿En qué puedo ayudarte hoy?", from: "bot" }
    ]);
    const [input, setInput] = useState("");
    
    const handleSend = () => {
        const trimmedInput = input.trim();

        if (trimmedInput === "") return;

        setMessages(prev => [...prev, { text: trimmedInput, from: "user" }]);
        setInput("");
        
        setLoading(true);
        fetch(`${baseUrl}Messages/Chat`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                idSupport,
                message: trimmedInput,
                contactType: "chat",
                dateTime: new Date().toISOString(),
                url: window.location.href,
            }),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al enviar el mensaje');
            }
            return response.json();
        })
        .then(data => {
            console.log("Respuesta del bot:", data);
            if (data.idSupport) {
                setIdSupport(data.idSupport);
            }
            setMessages(prev => [...prev, { text: data.response, from: "bot" }]);
        })
        .catch(error => {
            console.error("Error al enviar el mensaje:", error);
            setMessages(prev => [...prev, { text: "Lo siento, ocurrió un error al procesar tu mensaje.", from: "bot" }]);
        })
        .finally(() => {
            setLoading(false);
            setInput("");
        });

    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSend();
        }
    };

    return (
        <div className="chatbot-content">
            <div className="chatbox-messages">
                {messages.map((msg, idx) => (
                    <div
                        key={idx}
                        className={`chatbox-message${msg.from === "user" ? " user" : ""}`}
                    >
                        {msg.text.split('\n').map((line, i) => (
                            <React.Fragment key={i}>
                                {line}
                                {i < msg.text.split('\n').length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </div>
                ))}
            </div>
            <div className="chatbox-input-container">
                <textarea
                    className="chatbox-input"
                    placeholder="Escribe tu mensaje..."
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={loading}
                />
                <button className="chatbox-send-btn" onClick={handleSend} disabled={loading || !input.trim()}>
                    {loading ? 'Enviando...' : 'Enviar'}
                </button>
            </div>
        </div>
    );
};

export default Contacta;